"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[947],{

/***/ 6947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ route_home_ListAppendBottomSheet; }
});

// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5578);
// EXTERNAL MODULE: ./.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(9953);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-styled-virtual-2aaf7f2de3/0/cache/@emotion-styled-npm-11.10.0-ee745c48ee-f2a3e9798f.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(102);
// EXTERNAL MODULE: ./src/components/button/LabelButton.tsx
var LabelButton = __webpack_require__(1919);
// EXTERNAL MODULE: ./src/components/icon/IconAdd.tsx
var IconAdd = __webpack_require__(2976);
// EXTERNAL MODULE: ./src/components/navigation/AppBar.tsx
var AppBar = __webpack_require__(54);
// EXTERNAL MODULE: ./src/components/portal/BottomSheet.tsx
var BottomSheet = __webpack_require__(8337);
// EXTERNAL MODULE: ./.yarn/__virtual__/@emotion-react-virtual-5128de1cdb/0/cache/@emotion-react-npm-11.10.0-06b9abb1e2-6d692e43ff.zip/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(2746);
// EXTERNAL MODULE: ./src/components/icon/IconCancelSmall.tsx
var IconCancelSmall = __webpack_require__(7329);
;// CONCATENATED MODULE: ./src/components/tag/EditableTag.tsx





const EditableTag = (param)=>{
    let { editable =false , value ="" , onChange , placeholder , onClickCancel , onChangedEmpty  } = param;
    const isInitialEditing = editable && value === "";
    const [isEditing, setIsEditing] = (0,react.useState)(isInitialEditing);
    const inputRef = (0,react.useRef)(null);
    const isShowingIconCancel = Boolean(!isEditing && onClickCancel);
    const onClickTextButton = ()=>{
        var ref;
        setIsEditing(true);
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const onSubmit = (e)=>{
        e.preventDefault();
        endEditing();
    };
    const endEditing = ()=>{
        if (value.trim().length === 0 && onChangedEmpty) {
            onChangedEmpty();
            return;
        }
        setIsEditing(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form, {
        onSubmit: onSubmit,
        isEditing: isEditing,
        isShowingIconCancel: isShowingIconCancel,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input, {
                type: "text",
                ref: inputRef,
                value: value,
                onChange: onChange,
                onBlur: endEditing,
                placeholder: placeholder,
                isEditing: isEditing,
                style: {
                    width: "".concat((value.length + 1) / 2, "rem")
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button, {
                editable: editable,
                isEditing: isEditing,
                type: "button",
                onClick: onClickTextButton,
                disabled: !editable,
                children: value
            }),
            isShowingIconCancel && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyButton, {
                type: "button",
                onClick: onClickCancel,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCancelSmall/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var tag_EditableTag = (EditableTag);
const Form = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("form", {
    target: "e1ez7rv0"
})({
    minWidth: "2.375rem",
    width: "fit-content",
    maxWidth: "100%",
    height: "38px",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    borderRadius: "8px"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.button2,
        backgroundColor: theme.colors.gray1,
        color: theme.colors.gray6
    };
}, (param)=>{
    let { isEditing , theme  } = param;
    return {
        border: isEditing ? "1px solid ".concat(theme.colors.gray3) : "none"
    };
}, (param)=>{
    let { isShowingIconCancel  } = param;
    return isShowingIconCancel ? {
        paddingTop: "7px",
        paddingBottom: "7px",
        paddingLeft: "8px",
        paddingRight: "4px"
    } : {
        padding: "7px 8px"
    };
});
const Input = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("input", {
    target: "e1ez7rv1"
})({
    all: "unset",
    boxSizing: "border-box",
    maxWidth: "100%",
    minWidth: "100%"
}, (param)=>{
    let { theme  } = param;
    return {
        caretColor: theme.colors.secondary
    };
}, (param)=>{
    let { isEditing  } = param;
    return !isEditing && hideCss;
});
const Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1ez7rv2"
})({
    all: "unset",
    maxWidth: "100%",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap"
}, (param)=>{
    let { editable  } = param;
    return {
        cursor: editable ? "pointer" : "text"
    };
}, (param)=>{
    let { isEditing  } = param;
    return isEditing && hideCss;
});
const hideCss = /*#__PURE__*/ (0,emotion_react_browser_esm.css)({
    clipPath: "polygon(0 0, 0 0, 0 0)",
    position: "absolute",
    minWidth: "auto",
    width: "0 !important"
});
const EmptyButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1ez7rv3"
})({
    all: "unset",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});

// EXTERNAL MODULE: ./src/components/text-field/TextField.tsx
var TextField = __webpack_require__(7043);
// EXTERNAL MODULE: ./src/components/toggle/ToggleSwitch.tsx
var ToggleSwitch = __webpack_require__(6744);
// EXTERNAL MODULE: ./src/hooks/common/useInput.ts
var useInput = __webpack_require__(6650);
;// CONCATENATED MODULE: ./src/components/route-home/ListAppendBottomSheet.tsx











const ListAppendBottomSheet = (param)=>{
    let { isShowing , setToClose  } = param;
    const { value: listName , onChange: onListNameChange , debouncedValue: debouncedListName  } = (0,useInput/* default */.Z)({
        initialValue: "",
        useDebounce: true
    });
    const isSubmitDisabled = debouncedListName.length === 0;
    const { items , onChangeItem , appendEmptyItem , deleteWithIndex  } = useItemList();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomSheet["default"], {
        isShowing: isShowing,
        setToClose: setToClose,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppBar/* default */.Z, {
                backButtonType: "cancel",
                onClickBackButton: setToClose,
                title: "리스트 추가",
                rightElement: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelButton/* default */.Z, {
                    size: "large",
                    disabled: isSubmitDisabled,
                    children: "완료"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextFieldWrapper, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* default */.Z, {
                    placeholder: "리스트 입력",
                    value: listName,
                    onChange: onListNameChange
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ToggleWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: "매일 반복"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleSwitch/* default */.Z, {
                        defaultChecked: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemFieldset, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Legend, {
                        children: "소지품"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemWrapper, {
                        children: [
                            items.map((item, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tag_EditableTag, {
                                    editable: true,
                                    value: item,
                                    onChange: onChangeItem(index),
                                    onClickCancel: ()=>deleteWithIndex(index),
                                    onChangedEmpty: ()=>deleteWithIndex(index)
                                }, index)),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BgLabelButton, {
                                size: "large",
                                onClick: appendEmptyItem,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconAdd/* default */.Z, {}),
                                    "추가하기"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var route_home_ListAppendBottomSheet = (ListAppendBottomSheet);
const TextFieldWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebkdszl0"
})({
    marginTop: "8px"
});
const ToggleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebkdszl1"
})({
    all: "unset",
    marginTop: "16px",
    height: "52px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        color: theme.colors.gray6,
        ...theme.divider
    };
});
const ItemFieldset = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("fieldset", {
    target: "ebkdszl2"
})({
    width: "100%"
});
const Legend = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("legend", {
    target: "ebkdszl3"
})({
    height: "52px",
    display: "flex",
    alignItems: "center"
}, (param)=>{
    let { theme  } = param;
    return {
        ...theme.typographies.body1,
        color: theme.colors.gray6
    };
});
const ItemWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebkdszl4"
})({
    width: "100%",
    display: "flex",
    gap: "8px",
    overflowY: "scroll",
    "& *": {
        flexShrink: "0"
    }
});
const BgLabelButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(LabelButton/* default */.Z, {
    target: "ebkdszl5"
})((param)=>{
    let { theme  } = param;
    return {
        color: theme.colors.gray4,
        backgroundColor: theme.colors.gray1
    };
});
const useItemList = ()=>{
    const [items, setItems] = (0,react.useState)([]);
    const appendEmptyItem = ()=>{
        setItems((prev)=>[
                ...prev,
                ""
            ]);
    };
    const onChangeItem = (index)=>(e)=>{
            setItems((prev)=>{
                const temp = [
                    ...prev
                ];
                temp[index] = e.target.value;
                return temp;
            });
        };
    const deleteWithIndex = (index)=>{
        setItems((prev)=>prev.filter((_, i)=>i !== index));
    };
    return {
        items,
        appendEmptyItem,
        deleteWithIndex,
        onChangeItem
    };
};


/***/ })

}]);